// One source of patient-facing Easy Read role names and descriptions for
// Journey cards, stage people lists, and printable evaluation copies.
// The canonical role's formal job title is deliberately left unchanged.
function references(role) {
  return [role?.id, role?.role_key, role?.roleKey, ...(role?.legacy_alias_ids || []), ...(role?.legacy_alias_role_keys || [])]
    .filter(Boolean).map(String);
}

export function findEasyReadRoleReference(role, journeyRoles = []) {
  const keys = new Set(references(role));
  return journeyRoles.find((candidate) => references(candidate).some((key) => keys.has(key))) || null;
}

export function getEasyReadRoleCopy(role, journeyRoles = []) {
  const reference = findEasyReadRoleReference(role, journeyRoles);
  return {
    title: reference?.shortTitle || role?.shortTitle || role?.title || 'Hospital staff member',
    description: reference?.shortDescription || role?.shortDescription || '',
  };
}

export function getEasyReadDisplayRoles(journey, resolvedRoles = []) {
  if (!journey?.simplifiedRoles) return resolvedRoles;
  // Preserve every source staff role in Easy Read, even when a canonical
  // job-detail/uniform lookup cannot be resolved on a particular device.
  return (journey.roles || []).map((reference) => {
    const matched = resolvedRoles.find((candidate) => findEasyReadRoleReference(candidate, [reference]));
    return {
      ...reference,
      ...(matched || {}),
      id: matched?.id || reference.id,
      easyReadResolved: Boolean(matched),
      shortTitle: reference.shortTitle || matched?.shortTitle,
      shortDescription: reference.shortDescription || matched?.shortDescription,
    };
  });
}
